var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoginToChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.847 1.628c.071.173.108.358.108.546h.01v11.642H2.045V2.174A1.426 1.426 0 013.47.748H20.53a1.426 1.426 0 011.317.88zM3.708 12.153h16.584V2.41H3.708v9.742zm10.43 2.378a.528.528 0 00-.057-.24H24c0 1.083-.977 1.961-2.177 1.961H2.177C.974 16.252 0 15.374 0 14.292h9.92a.528.528 0 00.098.618c.1.1.237.156.379.156h3.206a.535.535 0 00.535-.535z",
    fill: "#F7F8F9"
  })));
}
export default SvgLoginToChat;